import { auth, db } from '@/firebase'
import {
  setDoc,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
  addDoc,
  collection,
  getDocs,
  deleteDoc,
  onSnapshot,
  DocumentData,
  collectionGroup,
  where,
  runTransaction,
  query,
  writeBatch,
  limit,
  orderBy,
} from 'firebase/firestore'

import { EatLogType } from '@/types/logs'
import { SetStateAction } from 'react'

const collectionRef = collection(db, 'logs')

export const setEatLog = async (
  userId: string,
  eatLog: EatLogType,
  successCb: () => void,
  errCb: () => void,
) => {
  try {
    const q = query(
      collectionRef,
      where('userId', '==', userId),
      where('shopId', '==', eatLog.shopId),
    )
    const logs = await getDocs(q)
    const isExist = logs.size > 0
    const updatedAt = serverTimestamp()
    const batch = writeBatch(db)
    if (isExist) {
      const id = logs.docs[0].id
      const docRef = doc(collectionRef, id)
      batch.update(docRef, { ...eatLog, updatedAt })
      batch.update(doc(db, 'social', userId, 'logs', id), {
        ...eatLog,
        updatedAt,
      })
    } else {
      const autoId = doc(collectionRef).id
      const logDoc = doc(collectionRef, autoId)
      batch.set(logDoc, {
        ...eatLog,
        id: autoId,
        updatedAt,
      })
      batch.set(doc(db, 'social', userId, 'logs', autoId), {
        ...eatLog,
        id: autoId,
        updatedAt,
      })
    }
    await batch.commit()
    successCb()
  } catch (error) {
    console.log(error)
    errCb()
  }
}

export const getAllLog = async (userId: string) => {
  const collectionRef = collection(db, 'social', userId, 'logs')
  const docsSnap = await getDocs(collectionRef)
  const logs = docsSnap.docs.map((doc) => doc.data())
  return logs
}

export const listenAllLog = (userId: string, setState: SetStateAction<any>) => {
  const collectionRef = collection(db, 'social', userId, 'logs')
  const unSub = onSnapshot(collectionRef, (snapshot) => {
    const allLog = snapshot.docs.map((document) => ({ ...document.data() }))
    setState(allLog)
  })
  return unSub
}

export const setLike = async (
  userId: string,
  shopId: number,
  successCb: () => void,
  errCb: () => void,
) => {
  try {
    await runTransaction(db, async (transaction) => {
      const likesRef = doc(db, 'social', userId, 'likes', String(shopId))
      const isExsist = (await transaction.get(likesRef)).exists()
      if (!isExsist) {
        transaction.set(likesRef, { id: shopId, updatedAt: serverTimestamp() })
      } else {
        transaction.delete(likesRef)
      }
    })
    successCb()
  } catch (error) {
    console.log(error)
    errCb()
  }
}

export const getPickUpLogs: () => Promise<EatLogType[]> = async () => {
  const q = query(
    collectionRef,
    where('satisfaction', '==', 5),
    where('userId', '!=', auth.currentUser.uid),
    limit(10),
    orderBy('userId', 'asc'),
    orderBy('updatedAt', 'asc'),
  )
  const snapshot = await getDocs(q)
  const data = snapshot.docs.map((document) => document.data())
  function shuffle(array): EatLogType[] {
    let obj = {}
    for (let i = 0; i < array.length; i++) {
      // ランダムな数値を生成する ※配列の数より少ないと永久ループする
      let rand = Math.floor(Math.random() * 10000000)
      // 同じキー名がないか判別する
      if (!obj[rand]) {
        // 同じキー名がない場合にobjに追加する
        obj[rand] = array[i]
      } else {
        // 同じキー名ある場合、やり直す
        i--
      }
    }
    // 作成したオブジェクトの値から配列を作成して返す
    return Object.values(obj)
  }
  const pickUps: EatLogType[] = shuffle(data).filter((_, i) => i <= 2)
  return pickUps
}

export const getAllLikes = async (userId: string) => {
  const collectionRef = collection(db, 'social', userId, 'likes')
  const docsSnap = await getDocs(collectionRef)
  const likes = docsSnap.docs.map((doc) => doc.data())
  return likes
}

export const listenAllLikes = (
  userId: string,
  setState: SetStateAction<any>,
) => {
  const collectionRef = collection(db, 'social', userId, 'likes')
  const unSub = onSnapshot(collectionRef, (snapshot) => {
    const allLikes = snapshot.docs.map((document) => ({ ...document.data() }))
    setState(allLikes)
  })
  return unSub
}

export const listenIsShopLike = (
  userId: string,
  shopId: number,
  setState: SetStateAction<any>,
) => {
  const docRef = doc(db, 'social', userId, 'likes', String(shopId))
  const unSub = onSnapshot(docRef, (snapshot) => {
    setState(snapshot.exists())
  })
  return unSub
}
